import {
    Box,
    Container,
    Grid,
    Skeleton,
    Stack,
    styled,
    SwipeableDrawer,
    TextField,
    Typography,
    IconButton,
    Button,
    CircularProgress,
    Divider,
    Snackbar,
} from "@mui/material";
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    limit,
    orderBy,
    query,
    serverTimestamp,
    setDoc,
    where,
} from "firebase/firestore";
import React, { useState } from "react";
import { UserAuth } from "../../context/AuthContext";
import { db } from "../../firebase.config";
import CustomButton from "../../Components/CustomButton";
import EventCard from "../../Components/EventCard";
import Iconify from "../../Components/Iconify";
import { sendPasswordResetEmail } from "firebase/auth";
import { Facebook, Google } from "@mui/icons-material";
import { Variables } from "../../context/VariableContext";
import CustomTextField from "../../Components/CustomTextField";
import QRCodeGenerator from "../../Components/QrGenerator";

const Info = ({ affiliation }) => {
    const { openLogin, setOpenLogin } = Variables();
    const [loading, setLoading] = React.useState(false);
    const [events, setEvents] = React.useState([]);
    const [countTmp, setCount] = React.useState(0);
    const createEventList = (doc) => {
        setEvents((events) => [...events, doc]); // ajouter a la fin
    };
    React.useEffect(() => {
        (async () => {
            try {
                //
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        })();
    }, []);

    const handleCopyLink = (link) => {
        navigator.clipboard.writeText(link)
        setMsg({ content: 'Lien copié dans le papier presse', color: 'green' });
        setOpenSnack(true);
    };

    const handleCopyCode = (code) => {
        navigator.clipboard.writeText(code)
        setMsg({ content: 'Code copié dans le papier presse', color: 'green' });
        setOpenSnack(true);
    };

    //  snack bar
    const [openSnack, setOpenSnack] = React.useState(false);
    const [msg, setMsg] = React.useState({ content: '', color: '' });
    const handleCloseSnack = () => {
        setOpenSnack(false);
    };


    return (
        <Box>
            {
                affiliation &&
                <Grid container sx={{ color: 'white' }}>
                    <Grid item xs={12} sm={8}>
                        <Stack spacing={2}>
                            <Stack spacing={1}>
                                <Typography variant="subtitle1">Lien de tracking</Typography>
                                <Stack direction='row' spacing={1} alignItems='center'>
                                    <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#292929', borderRadius: '5px' }} padding={2}>
                                        <Iconify icon='material-symbols:link' />
                                        <Typography sx={{ maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} noWrap paddingLeft={1}>{affiliation?.data().affiliateLink}</Typography>
                                    </Box>
                                    <Box sx={{ bgcolor: '#5E17EB', borderRadius: '5px' }} padding={1}>
                                        <IconButton onClick={() => handleCopyLink(affiliation?.data().affiliateLink)}>
                                            <Iconify icon='ph:copy' />
                                        </IconButton>
                                    </Box>
                                </Stack>
                                <Typography variant="body2">Avec ce lien beneficier d'une commission de <strong>{affiliation?.data().commission?.value} {affiliation?.data().commission?.type === 1 ? '%' : 'CFA'}</strong> sur chaque achat</Typography>
                            </Stack>
                            {
                                affiliation?.data().promoId ?
                                    <Stack spacing={1}>
                                        <Typography variant="subtitle1">Code Promo</Typography>
                                        <Stack direction='row' spacing={1} alignItems='center'>
                                            <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: '#292929', borderRadius: '5px' }} padding={2}>
                                                <Iconify icon='bxs:discount' />
                                                <Typography noWrap paddingLeft={1}>{affiliation?.data().promoId}</Typography>
                                            </Box>
                                            <Box sx={{ bgcolor: '#5E17EB', borderRadius: '5px' }} padding={1}>
                                                <IconButton onClick={() => handleCopyCode(affiliation?.data().promoId)}>
                                                    <Iconify icon='ph:copy' />
                                                </IconButton>
                                            </Box>
                                        </Stack>
                                        <Typography variant="body2">Ce code de promo offre une reduction de <strong>5%</strong> a votre communauté</Typography>
                                        <Typography variant="body2" color='yellow'>Valable uniqument avec votre lien de tracking</Typography>
                                    </Stack>
                                    : null
                            }

                            <Typography variant="caption">Affialition effective a partir du 02 septembre 2023</Typography>

                        </Stack>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <QRCodeGenerator value={affiliation?.data().affiliateLink} />
                    </Grid>
                </Grid>
            }
            <Snackbar
                open={openSnack}
                autoHideDuration={5000}
                onClose={handleCloseSnack}
                message={
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography paddingRight={1} variant='body2'>{msg.content}{' '}</Typography>
                        <Iconify
                            sx={{ color: msg.color }}
                            icon={`${msg.red ? 'system-uicons:cross-circle' : 'mdi:success-circle-outline'}`}
                        />
                    </Box>
                }
            />
        </Box>
    );
};

export default Info;
